import SearchableSelect from "Components/Common/SearchableSelect";
import {
  adminGetAllPatrolExcel,
  adminGetComboMember,
  adminGetComboPatrol,
} from "helpers/backend_helpers";
import moment from "moment";
import { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { toast } from "react-toastify";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const DownloadModalWorkActivities = ({ show, onCloseClick }: any) => {
  const menu: any = sessionStorage.getItem("menu");
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterMember, setFilterMember] = useState<any>(null);
  const [filterLocation, setFilterLocation] = useState<any>(null);
  const [flatpickrKey, setFlatpickrKey] = useState(0);
  const [downloadType, setDownloadType] = useState<string>("all");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const searchMembers = async (name: string) => {
    const query = { name };
    return await adminGetComboMember(query);
  };

  const formatMemberOption = (member: any) => {
    return {
      label: `${member.name} - ${member.noId}`,
      value: member._id,
    };
  };

  const searchLocation = async (name: string) => {
    const query = { name };
    return await adminGetComboPatrol(query);
  };

  const formatLocationOption = (location: any) => {
    return {
      label: `${location.name}`,
      value: location._id,
    };
  };

  const handleDownloadTypeChange = (type: string) => {
    setDownloadType(type);
    if (type === "all") {
      setFilterDate([]);
      setFilterLocation(null);
      setFilterMember(null);
      setFlatpickrKey((prev) => prev + 1);
    }
  };

  const downloadData = async () => {
    if (downloadType === "specific") {
      const hasDateFilter = filterDate[0] && filterDate[1];
      const hasMemberFilter = filterMember !== null;
      const hasLocationFilter = filterLocation !== null;

      if (!hasDateFilter && !hasMemberFilter && !hasLocationFilter) {
        toast.error("Pilih minimal satu filter untuk download data tertentu!");
        return;
      }
    }
    setIsLoading(true);
    try {
      let query: any = {};

      if (downloadType === "specific") {
        if (filterDate[0] && filterDate[1]) {
          query.startDate = moment(filterDate[0]).format("YYYY-MM-DD");
          query.endDate = moment(filterDate[1]).format("YYYY-MM-DD");
        }
        if (filterMember) {
          query.userId = filterMember.value;
        }
        if (filterLocation) {
          query.idCheckPoint = filterLocation.value;
        }
      }

      const response: any = await adminGetAllPatrolExcel(query);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Data Aktivitas Pekerjaan.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Unduh data aktivitas pekerjaan berhasil");
      onCloseClick();
    } catch (error) {
      toast.error("Gagal mengunduh data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!show) {
      setFilterDate([]);
      setFilterLocation(null);
      setFilterMember(null);
      setDownloadType("all");
      setFlatpickrKey((prev) => prev + 1);
      setIsLoading(false);
    }
  }, [show]);

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="md"
    >
      <ModalHeader
        className="bg-gradient-to-r from-blue-50 to-indigo-50 border-0 p-4"
        toggle={onCloseClick}
      >
        <div className="d-flex align-items-center">
          {/* <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
            <i className="ri-download-2-line text-primary fs-5"></i>
          </div> */}
          <div>
            <h5 className="mb-0 text-dark fw-semibold">
              Unduh Data Aktivitas Pekerjaan
            </h5>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        <div className="mb-4">
          <Label className="form-label text-dark fw-semibold mb-3">
            Pilih Tipe Unduhan
          </Label>
          <div className="d-flex gap-3">
            <div
              className={`flex-fill border rounded-3 p-3 cursor-pointer transition-all ${
                downloadType === "all"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25 hover:border-primary"
              }`}
              onClick={() => handleDownloadTypeChange("all")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadAll"
                  checked={downloadType === "all"}
                  onChange={() => handleDownloadTypeChange("all")}
                />
                <Label
                  className="form-check-label d-flex align-items-center cursor-pointer"
                  htmlFor="downloadAll"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-folder-download-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Semua Data</div>
                    <small className="text-muted">
                      Download semua aktivitas pekerjaan
                    </small>
                  </div>
                </Label>
              </div>
            </div>

            <div
              className={`flex-fill border rounded-3 p-3 cursor-pointer transition-all ${
                downloadType === "specific"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25 hover:border-primary"
              }`}
              onClick={() => handleDownloadTypeChange("specific")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadSpecific"
                  checked={downloadType === "specific"}
                  onChange={() => handleDownloadTypeChange("specific")}
                />
                <Label
                  className="form-check-label d-flex align-items-center cursor-pointer"
                  htmlFor="downloadSpecific"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-filter-3-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Data Tertentu</div>
                    <small className="text-muted">
                      Filter data aktivitas pekerjaan
                    </small>
                  </div>
                </Label>
              </div>
            </div>
          </div>
        </div>

        {downloadType === "specific" && (
          <div className="animate-fade-in">
            <div className="border-top pt-4 mt-2">
              <Label className="form-label text-dark fw-semibold mb-3">
                <i className="ri-filter-line me-2"></i>
                Filter Data
              </Label>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-calendar-line me-1"></i>
                  Rentang Tanggal
                </Label>
                <Flatpickr
                  key={flatpickrKey}
                  className="form-control shadow-sm"
                  options={{
                    mode: "range",
                    dateFormat: "d M Y",
                  }}
                  onChange={(e) => {
                    setFilterDate(e);
                  }}
                  value={filterDate}
                  placeholder="Pilih rentang tanggal"
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-user-search-line me-1"></i>
                  Karyawan
                </Label>
                <SearchableSelect
                  value={filterMember}
                  onChange={setFilterMember}
                  onSearch={searchMembers}
                  formatOptionLabel={formatMemberOption}
                  placeholder="Cari karyawan..."
                  minSearchLength={2}
                  itemsPerPage={5}
                  isClearable
                />
              </div>

              {menu.includes("PATROL_LOCATION") && (
                <div className="mb-3">
                  <Label className="form-label text-muted small mb-2">
                    <i className="mdi mdi-google-maps me-1"></i>
                    Lokasi Aktivitas Pekerjaan
                  </Label>
                  <SearchableSelect
                    value={filterLocation}
                    onChange={setFilterLocation}
                    onSearch={searchLocation}
                    formatOptionLabel={formatLocationOption}
                    placeholder="Cari Lokasi Aktivitas Pekerjaan..."
                    minSearchLength={2}
                    itemsPerPage={5}
                    isClearable
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter className="bg-light border-0 p-4">
        <button
          type="button"
          className="btn btn-light border shadow-sm px-4 btn-sm"
          onClick={onCloseClick}
          disabled={isLoading}
        >
          <i className="ri-close-line me-1"></i>
          Batal
        </button>
        <button
          type="button"
          className="btn btn-primary shadow-sm px-4 btn-sm"
          onClick={downloadData}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Mengunduh...
            </>
          ) : (
            <>
              <i className="ri-download-2-line me-1"></i>
              Unduh Data
            </>
          )}
        </button>
      </ModalFooter>

      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .hover\\:border-primary:hover {
          border-color: #6366f1 !important;
        }

        .transition-all {
          transition: all 0.2s ease-in-out;
        }

        .cursor-pointer {
          cursor: pointer;
        }

        .bg-opacity-10 {
          --bs-bg-opacity: 0.1;
        }

        .border-opacity-25 {
          --bs-border-opacity: 0.25;
        }
      `}</style>
    </Modal>
  );
};

export default DownloadModalWorkActivities;
